import {
  Button,
  Card,
  Col,
  Flex,
  Input,
  Popover,
  Row,
  Typography,
  Image,
  Dropdown,
  Space,
  MenuProps,
  Badge,
  message,
  Segmented,
  Collapse,
} from "antd";
import React, { useState } from "react";
import "./productComponent.scss";
import {
  AimOutlined,
  AppstoreFilled,
  BarsOutlined,
  CaretDownOutlined,
  DeleteOutlined,
  MailFilled,
  MonitorOutlined,
} from "@ant-design/icons";
import ProductListComponent from "./product-list-component/productListComponent";

import RightPenalComponent from "./right-penal-component/rightPenalComponent";
import ProductTileComponent from "./product-tile-component/productTileComponent";
import cat1 from "assets/images/cat1.png";

const { Text } = Typography;

const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      d="M22.15 5.50504C21.8474 5.19726 21.4342 5.01975 21 5.01102H5.75L5.55 3.33136C5.50128 2.97345 5.32198 2.64544 5.04578 2.40893C4.76958 2.17242 4.41548 2.04368 4.05 2.0469H2.5C2.23478 2.0469 1.98043 2.151 1.79289 2.33629C1.60536 2.52159 1.5 2.7729 1.5 3.03494C1.5 3.29699 1.60536 3.5483 1.79289 3.73359C1.98043 3.91889 2.23478 4.02298 2.5 4.02298H3.6L5.2 17.3121C4.75689 17.5706 4.38994 17.9392 4.13558 18.3812C3.88121 18.8232 3.74829 19.3232 3.75 19.8316C3.75 20.6178 4.06607 21.3717 4.62868 21.9276C5.19129 22.4835 5.95435 22.7957 6.75 22.7957C7.37069 22.7862 7.97417 22.5927 8.4823 22.2404C8.99043 21.8881 9.3798 21.3931 9.6 20.8197H14.9C15.1202 21.3931 15.5096 21.8881 16.0177 22.2404C16.5258 22.5927 17.1293 22.7862 17.75 22.7957C18.5456 22.7957 19.3087 22.4835 19.8713 21.9276C20.4339 21.3717 20.75 20.6178 20.75 19.8316C20.75 19.0455 20.4339 18.2916 19.8713 17.7357C19.3087 17.1798 18.5456 16.8675 17.75 16.8675C17.1293 16.8771 16.5258 17.0706 16.0177 17.4229C15.5096 17.7752 15.1202 18.2701 14.9 18.8436H9.6C9.4108 18.3307 9.08191 17.8793 8.6496 17.5394C8.21728 17.1994 7.69834 16.984 7.15 16.9169L7.05 15.8795H19.7C20.0568 15.8708 20.3989 15.7368 20.6646 15.5013C20.9304 15.2659 21.1025 14.9446 21.15 14.595L22.5 6.7895C22.5559 6.33273 22.4304 5.87235 22.15 5.50504ZM18.75 19.8316C18.75 20.027 18.6914 20.2181 18.5815 20.3806C18.4716 20.543 18.3154 20.6697 18.1327 20.7445C17.95 20.8192 17.7489 20.8388 17.5549 20.8007C17.3609 20.7626 17.1827 20.6685 17.0429 20.5303C16.903 20.3921 16.8078 20.216 16.7692 20.0244C16.7306 19.8327 16.7504 19.6341 16.8261 19.4535C16.9018 19.273 17.03 19.1187 17.1944 19.0101C17.3589 18.9015 17.5522 18.8436 17.75 18.8436C18.0152 18.8436 18.2696 18.9477 18.4571 19.133C18.6446 19.3183 18.75 19.5696 18.75 19.8316ZM7.75 19.8316C7.75 20.027 7.69135 20.2181 7.58147 20.3806C7.47159 20.543 7.31541 20.6697 7.13268 20.7445C6.94996 20.8192 6.74889 20.8388 6.55491 20.8007C6.36093 20.7626 6.18275 20.6685 6.04289 20.5303C5.90304 20.3921 5.8078 20.216 5.76921 20.0244C5.73063 19.8327 5.75043 19.6341 5.82612 19.4535C5.90181 19.273 6.02998 19.1187 6.19443 19.0101C6.35888 18.9015 6.55222 18.8436 6.75 18.8436C7.01522 18.8436 7.26957 18.9477 7.45711 19.133C7.64464 19.3183 7.75 19.5696 7.75 19.8316Z"
      fill="black"
    />
  </svg>
);

const currency: MenuProps["items"] = [
  {
    label: (
      <a
        href="https://www.antgroup.com"
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex justify-space-between"
      >
        <span className="text-left">INR</span>
        <span className="text-right">₹</span>
      </a>
    ),
    key: "0",
  },
  {
    label: (
      <a
        href="https://www.aliyun.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        2nd menu item
      </a>
    ),
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: "3rd menu item",
    key: "3",
  },
];

const handleMenuClick: MenuProps["onClick"] = (e) => {
  message.info("Click on menu item.");
  console.log("click", e);
};

const menuProps = {
  currency,
  onClick: handleMenuClick,
};

const data = ["Instant Confirmation", "Non Refundable"];

function ProductComponent() {
  const [selected, setSelected] = useState("List");
  const RenderComponent = () => {
    switch (selected) {
      case "List":
        return <ProductListComponent onTrigger={handleOpenChange} />;
      case "Tile":
        return <ProductTileComponent />;
      default:
        return <ProductListComponent />;
    }
  };

  const cartData: MenuProps["items"] = [
    {
      label: (
        <a
          href="https://www.antgroup.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          1st menu item
        </a>
      ),
      key: "0",
    },
    {
      label: (
        <a
          href="https://www.aliyun.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          2nd menu item
        </a>
      ),
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen: any) => {
    setOpen(newOpen);
  };
  const hide = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="top-header py-3 mb-5">
        <div className="container">
          <Flex
            justify={"space-between"}
            align={"center"}
            className="flex-direction-column-xs"
            gap={16}
          >
            <Text>
              All major attractions and tours across the UAE have been re-opened
              with Guidelines.  COVID-19 Guidelines & FAQ's
            </Text>
            <Flex justify={"space-between"} align={"center"} gap={"large"}>
              <Popover
                content={
                  <Flex gap={8} justify="start" wrap={"wrap"}>
                    <Button className="d-flex justify-space-between">
                      <span>INR</span> <span>₹</span>
                    </Button>

                    <Button className="d-flex justify-space-between">
                      <span>USD</span> <span>$</span>
                    </Button>

                    <Button className="d-flex justify-space-between">
                      <span>INR</span> <span>₹</span>
                    </Button>

                    <Button className="d-flex justify-space-between">
                      <span>INR</span> <span>₹</span>
                    </Button>

                    <Button className="d-flex justify-space-between">
                      <span>INR</span> <span>₹</span>
                    </Button>

                    <Button className="d-flex justify-space-between">
                      <span>INR</span> <span>₹</span>
                    </Button>
                  </Flex>
                }
                placement="bottom"
                color="#F1F3FC"
                overlayClassName="currencyPopover"
              >
                <Space>
                  <Typography.Title level={5} className="mt-0 mb-0">
                    AEC
                  </Typography.Title>
                  <CaretDownOutlined />
                </Space>
              </Popover>
              <Popover
                content={
                  <div>
                    <Flex
                      style={{
                        width: "100%",
                        msOverflowY: "auto",
                      }}
                      gap={15}
                      className="mb-2"
                    >
                      <Image
                        preview={false}
                        width={"50px"}
                        height={"50px"}
                        src={cat1}
                        className="border-8"
                      />
                      <div>
                        <Flex align="start" justify="space-between">
                          <Typography.Title
                            level={5}
                            className="mt-0 font-13 mb-0"
                          >
                            The Burj Khalifa Tickets
                          </Typography.Title>
                          <Button
                            color="danger"
                            variant="link"
                            type="link"
                            className="pr-0"
                          >
                            <DeleteOutlined />
                          </Button>
                        </Flex>

                        <Text className="font-11 font-weight-500 pr-4 d-block">
                          148th + 124th + 125th Floor Prime Hours Tickets <br />
                          Without Transfers <br />
                          01:00 hours (Approx) <br />
                          16:00 GST
                        </Text>
                        <Typography.Title
                          level={5}
                          className="mt-2"
                          color="danger"
                        >
                          <Text type="danger" className="font-14">
                            AED 425.00
                          </Text>
                        </Typography.Title>
                      </div>
                    </Flex>

                    <Flex
                      style={{
                        width: "100%",
                        msOverflowY: "auto",
                      }}
                      gap={15}
                      className="mb-2"
                    >
                      <Image
                        preview={false}
                        width={"50px"}
                        height={"50px"}
                        src={cat1}
                        className="border-8"
                      />
                      <div>
                        <Flex align="start" justify="space-between">
                          <Typography.Title
                            level={5}
                            className="mt-0 font-13 mb-0"
                          >
                            The Burj Khalifa Tickets
                          </Typography.Title>
                          <Button
                            color="danger"
                            variant="link"
                            type="link"
                            className="pr-0"
                          >
                            <DeleteOutlined />
                          </Button>
                        </Flex>

                        <Text className="font-11 font-weight-500 pr-4 d-block">
                          148th + 124th + 125th Floor Prime Hours Tickets <br />
                          Without Transfers <br />
                          01:00 hours (Approx) <br />
                          16:00 GST
                        </Text>
                        <Typography.Title
                          level={5}
                          className="mt-2"
                          color="danger"
                        >
                          <Text type="danger" className="font-14">
                            AED 425.00
                          </Text>
                        </Typography.Title>
                      </div>
                    </Flex>

                    <Flex
                      align="center"
                      justify="space-between"
                      className="graybg border-8 py-1 px-2 mt-3"
                    >
                      <Typography.Title level={5} className="mt-0 font-14 mb-0">
                        Total: AED 555.00
                      </Typography.Title>
                      <Button
                        color="danger"
                        variant="solid"
                        size="small"
                        type="link"
                        href="#/checkout"
                      >
                        Checkout
                      </Button>
                    </Flex>
                  </div>
                }
                title={
                  <Typography.Title level={5} className="mt-0 mb-4">
                    My Cart | 3
                  </Typography.Title>
                }
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottom"
                color="#F1F3FC"
                overlayClassName="addtoCart"
              >
                <Badge count={5}>
                  <Button className="p-0 m-0" type="link">
                    <CartIcon />
                  </Button>
                </Badge>
              </Popover>

              <a href="#">
                <Badge count={5}>
                  <MailFilled style={{ fontSize: "22px" }} />
                </Badge>
              </a>
            </Flex>
          </Flex>
        </div>
      </div>
      <div className="container">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={18}>
            <Card className="light-sky-color mb-3" size="small">
              <Flex
                align={"center"}
                justify="space-between"
                gap={15}
                className="flex-direction-column-xs"
              >
                <Space>
                  <AimOutlined
                    className="danger-color"
                    style={{ fontSize: "20px" }}
                  />
                  <Typography.Title level={5} className="mt-0 mb-0">
                    3 Things to do in Dubai
                  </Typography.Title>
                </Space>
                <Flex gap={15} className="flex-direction-column-xs">
                  <Space>
                    <Text>
                      <small>Sort Result by:</small>
                    </Text>

                    <Dropdown
                      menu={{
                        items: currency, // Pass currency as items
                      }}
                      trigger={["click"]}
                      className="eff-dropdown"
                    >
                      <Button>
                        <Space>
                          <small>Most Popular</small>
                          <CaretDownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </Space>
                  <Space>
                    <Input
                      placeholder="Search"
                      className="eff-dropdown"
                      allowClear
                    />
                  </Space>
                  <Space>
                    <Button
                      type="primary"
                      icon={<MonitorOutlined />}
                      size={"middle"}
                    />
                    <Segmented
                      size="middle"
                      className="segmented-danger p-0"
                      onChange={(value) => setSelected(value)}
                      options={[
                        {
                          value: "List",
                          icon: (
                            <BarsOutlined
                              style={{ fontSize: "20px", fontWeight: "700" }}
                            />
                          ),
                        },
                        {
                          value: "Tile",
                          icon: (
                            <AppstoreFilled
                              style={{ fontSize: "18px", fontWeight: "700" }}
                            />
                          ),
                        },
                      ]}
                    />
                  </Space>
                </Flex>
              </Flex>
            </Card>
            {/* <ProductTileComponent /> */}
            {RenderComponent()}
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={6}>
            <RightPenalComponent />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ProductComponent;
